module.exports = __webpack_public_path__ + "static/media/project_demo_4.18abe8bc.png";